module.exports = __webpack_public_path__ + "img/vg.ebcd7eb1.png";